import { useMemo } from 'react';
import { useGetDocumentPackageResultsQuery } from '../api';
export const useDocumentPackageResults = (params) => {
    const { data: resultsResponse, isLoading, isFetching, isError, error, refetch, } = useGetDocumentPackageResultsQuery(params);
    return useMemo(() => {
        const totalCount = resultsResponse?.count || 0;
        const results = resultsResponse?.results || [];
        const next = resultsResponse?.next;
        const previous = resultsResponse?.previous;
        return {
            results,
            totalCount,
            next,
            previous,
            isLoading,
            isFetching,
            isError,
            error,
            refetch,
        };
    }, [resultsResponse, isLoading, isFetching, isError, error, refetch]);
};
